import { Box, Typography, SVGIcon } from "src/components";

export default function StatisticsCard({ 
    icon, 
    iconSize=90,
    label, 
    value, 
    valueMeasurement,
    backgroundImage,
    backgroundOverlay="rgba(255, 255, 255, 0.4)",
    textColor="#000",
    tallCard
}) {

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      height: tallCard ? '170px' : '140px',
      border: '1px solid #D3D3D3',
      borderRadius: 2,
      p: 1.5,
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative'
    }}>
        {backgroundImage && (<>
            <Box
                component="img"
                src={backgroundImage}
                alt="stat background"
                sx={{
                    position: "absolute",
                    inset: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    zIndex: 0,
                    borderRadius: 2,
                }}
            />

            <Box
                sx={{
                    position: "absolute",
                    inset: 0,
                    bgcolor: backgroundOverlay,
                    zIndex: 1,
                }}
            /> 
            
        </>)}

        <Box sx={{
                position: 'absolute', 
                bottom: 0,
                pb: 0.5, 
                width: '100%', 
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                maxHeight: '100%'}}>

            {icon && <SVGIcon icon={icon} size={iconSize} sx={{zIndex: 2, filter: 'drop-shadow(0 4px 6px rgba(0,0,0,0.25))', mb: backgroundImage ? 1 : 0}} />}

            {value && (
                <Box sx={{ display: 'flex', gap: 0.5, mt: 1, mb: -1, alignItems: 'center', zIndex: 2, color: textColor }}>
                    <Typography variant="h3" fontWeight={600}>
                        {value}
                    </Typography>
                    {valueMeasurement && (
                        <Typography variant="subtitle1" fontWeight={600}>
                            {valueMeasurement}
                        </Typography>
                    )}
                </Box>
            )}
            
            {label && (
                <Typography variant="subtitle1" fontWeight={600} sx={{zIndex: 2, color: textColor}}>
                    {label}
                </Typography>
            )}
        </Box>
    </Box>
  );
}